
import { Component, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";
import { namespace } from "vuex-class";

const service = namespace("service");
const store = namespace("store");
const finance = namespace("finance");
const app = namespace("app");
const base = namespace("base");
@Component({})
export default class SettlementSuccess extends Vue {
  @service.Action getOrderDetail;
  @store.State storeData;
  @finance.Action getReceiptDetail;
  @app.State country;
  @service.Action getUri;
  @service.Action email;
  @service.Action sms;
  @base.Action jumpPrintPage;
  detailData: any = {
    orderStatus: "9",
    photoList: [],
    action: {
      printArray: []
    }
  };
  get breadData() {
    // 判断来源是服务还是挂账
    return this.onAccountTo
      ? [
          {
            name: t("finance.payment-management"),
            path: "/finance/on-account-manage"
          },
          { name: t("service.collecting-results") }
        ]
      : [
          {
            name: t("test.service-management"),
            path: "/service/index"
          },
          { name: t("service.collecting-results") }
        ];
  }
  get onAccountTo() {
    return this.$route.path === "/service/settlement-success-credit" ? true : false;
  }
  get orderId() {
    return this.$route.query.orderId;
  }
  get onAccountOrderId() {
    return this.$route.params.orderId;
  }
  get isGetQualification() {
    return this.$route.query.canLotteryLength === "0" ? false : true;
  }
  created() {
    this.init();
  }
  init() {
    this.getOrderDetail({
      orderNo: this.orderId
      // orderNo: this.onAccountOrderId
    }).then(data => {
      this.detailData = data.data;
    });
  }
  handleInvoice() {
    this.$router.push(`/service/make-invoice/${this.onAccountOrderId || this.orderId}`);
  }
  handleCopyMenuClick() {
    this.jumpPrintPage({
      category: "PRINT_PAYMENT_CREDENTIALS",
      documentNo: this.orderId
    });
  }
  handleCommand(command) {
    if (command === "Email") {
      this.email({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "SMS") {
      this.sms({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "Print") {
      this.getUri({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          window.open(res.data);
        }
      });
    } else if (command === "Share") {
      this.getUri({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$copyText(res.data).then(() => this.$message.success(t("v210831.copy-succeeded")));
        }
      });
    }
  }
}
